import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpandSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconExpandSimple"><Path fillRule="evenodd" clipRule="evenodd" d="M12 5H19V12H17.5V6.5H12V5ZM6.5 12V17.5H12V19H5V12H6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExpandSimple;
